import * as _handleResponse from 'typescript/clients/utilities/handle_http_response';

/**
 * A helper function to mock the method used to handle the response of an HTTP request.
 * use for jest testing
 */
export const handleResponseSpy = jest.spyOn(_handleResponse, '_handleResponse');
